import React, {useMemo} from 'react';
import { WithLoadingComponent, SVGLoader, Chart } from 'components/shared';

export const CustomKPIHoc = (props) => {
    const CustomActHoc = useMemo(() => WithLoadingComponent(KpiChart, props.httpService, <SVGLoader label="Loading..." />)(props), []);
    return <CustomActHoc />
}

export const KpiChart = (props) => {

    const { data, title, chart, timeline, size } = props;
    const series = timeline ? data.map(item => { return { name: item.dataName, data: item.dataValue.map(subItem => subItem.dataValue) } }) : [{ data: data.map(item => { return { name: item.dataName, y: item.dataValue } }) }];
    const categories = timeline ? data[0].dataValue.map(item => item.dataName.substring(0, 10)) : data.map(item => item.dataName);
    const options = {
        chart: {
            height: size.height,
            type: chart,
        },
        title: {
            text: title
        },
        credits: {
            enabled: false
        },
        series: series,
        xAxis: {
            categories: categories
        },
        tooltip: {
            pointFormat: '<span style="color:{point.color}"><b>{point.y}</b> <br/>'
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true
                },
                showInLegend: false
            },
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name} {point.y}</b>',
                },
                showInLegend: true
            },
            line: {
                dataLabels: {
                    enabled: true
                },
                enableMouseTracking: false
            }
        },
        exporting: {
            enabled: true,
            fallbackToExportServer: false
        }
    };

    return (
        <div style={{ width: size.width }}>
            <Chart
                options={options}
                downloadReport={props.downloadReportService}
            />
        </div>
    )
}